export enum AttendingForEnum {
  RESIDENT = "resident",
  RESPITE = "respite",
  DAY_CENTRE = "day_centre",
  NIGHT_SHELTER = "night_shelter",
}

export const AttendingForNameMap: Record<string, string> = {
  [AttendingForEnum.RESIDENT]: "Resident",
  [AttendingForEnum.RESPITE]: "Respite",
  [AttendingForEnum.DAY_CENTRE]: "Day Centre",
  [AttendingForEnum.NIGHT_SHELTER]: "Night Shelter",
};

export const AttendingForDropdownOptions = Object.values(AttendingForEnum).map(
  (value) => ({
    label: AttendingForNameMap[value] || value,
    value,
  }),
);
